<style lang="scss">
  @import '~bulma/sass/utilities/all';

  .app-alerts {
    position: fixed;
    z-index: 4999;
    top: 0;
    left: 0;
    width: 100%;
    height: 0%;

    .slide-down-enter-active,
    .slide-down-leave-active,
    .slide-down-move {
      transition: all 0.6s;
    }
    .slide-down-enter, .slide-down-leave-to {
      opacity: 0;
      transform: translateY(-30px);
    }

    .notification {
      max-width: 600px;
      margin: pxToEm(10) auto;

      @include touch() {
        max-width: none;
        width: 100%;
        margin: 0 0 pxToEm(10);
      }
    }
  }
</style>

<template>
  <transition-group
    class="app-alerts"
    name="slide-down"
    tag="div"
    v-show="alerts.length">
    <div class="notification"
      v-for="alert in alerts"
      :class="'is-' + alert.type"
      :key="alert.id">
      <button class="delete" @click="close(alert.id)"></button>
      {{ $t(alert.trans.text, alert.trans.data) }}
    </div>
  </transition-group>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    computed: {
      ...mapState({
        alerts: state => state.Alerts.alerts
      })
    },

    methods: {
      close(id) {
        this.$store.commit('Alerts/remove', { id })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Alerts.vue?43ed61b8